/**
 * Libellés de la file de modération (lot 5) : types, gravités, fils.
 */
import type { Gravite, TypeElement } from './services/aTraiterApi';

export const LIBELLE_TYPE: Record<TypeElement, string> = {
  detresse: 'Détresse',
  relire: 'Message à relire',
  incident: 'Incident',
  ia: 'Signalement IA',
  exercice: "Signalement d'exercice",
};

export const LIBELLE_GRAVITE: Record<Gravite, string> = { haute: 'Haute', moyenne: 'Moyenne', basse: 'Basse' };

/** Couleur MUI (palette du thème) de chaque gravité. */
export const COULEUR_GRAVITE: Record<Gravite, 'error' | 'warning' | 'default'> = {
  haute: 'error', moyenne: 'warning', basse: 'default',
};

export const LIBELLE_FIL: Record<string, string> = {
  parentChild: 'Parent ↔ enfant',
  parentTeacher: 'Parent ↔ enseignant',
  teacherStudent: 'Enseignant ↔ élève',
  tuteurEleve: 'Tuteur ↔ élève',
};

/** Clé de cache de la file (invalidée après chaque action). */
export const CLE_FILE = 'moderation-a-traiter';

/** Rafraîchissement du nombre affiché dans le menu. */
export const RAFRAICHISSEMENT_MS = 60_000;
